import "./Login.css";

import { Button, Form, Input, message } from "antd";
import { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import {
  //  useAppSelector,
  userLogin,
} from "../../_lib/_store";

export const LoginPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  // const { user } = useAppSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const isAuthenticated = localStorage.getItem("token");

  const onFinish = async (values: { email: string; password: string }) => {
    setIsLoading(true);
    await userLogin(values, messageApi);
    setIsLoading(false);
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated]);

  return (
    <>
      {contextHolder}
      <div className="loginContainer">
        <div className="logoBox">
          <img src="/logo.png" alt="Logo" />
          <p className="logo">Rise OS</p>
        </div>
        <div className="login-container">
          <h1 className="login-title">Login</h1>
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            requiredMark={false}
            autoComplete="off"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please input your email address!" },
              ]}
            >
              <Input size="large" placeholder="Email address" />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input
                size="large"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                suffix={
                  showPassword ? (
                    <FiEye
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  ) : (
                    <FiEyeOff
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  )
                }
              />
            </Form.Item>

            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              Login
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};
